var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sliding",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297.4 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.4,116c1.4-0.1,2.5-1.2,2.6-2.6V86.6c0-1.4-1.1-2.5-2.6-2.6c-1.4,0.1-2.5,1.2-2.6,2.6v27.1 C256.1,115,257.1,115.9,258.4,116z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.2,14.9H46.6v166.9h205.6V14.9z M139.7,176.2H52.2V20.5h87.5V176.2z M152.4,176.2h-6.9V20.5h6.9L152.4,176.2z  M246.6,176.2H158V20.5h88.5L246.6,176.2z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 56.6,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 19.9,
    width: 4.8,
    height: 159.9,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 98.1,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 140.7,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.4,
    y: 56.6,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.9,
    y: 19.9,
    width: 4.8,
    height: 159.9,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.4,
    y: 98.1,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.4,
    y: 140.7,
    width: 89.9,
    height: 4.8,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.4,197.4H39c-6.7,0-12.1-5.4-12.1-12.1V14.8c0-6.7,5.4-12.1,12.1-12.1h219.4c6.7,0,12.1,5.4,12.1,12.1v170.5 C270.5,191.9,265.1,197.4,258.4,197.4z M39,7.9c-3.8,0-6.9,3.1-6.9,6.9v170.5c0,3.8,3.1,6.9,6.9,6.9h219.4c3.8,0,6.9-3.1,6.9-6.9 V14.8c0-3.8-3.1-6.9-6.9-6.9H39z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliding);
export default __webpack_public_path__ + "static/media/sliding.46785470418f1dcaf32d05ba20e39e6a.svg";
export { ForwardRef as ReactComponent };